import { render } from "./MasterProductList.vue?vue&type=template&id=64f4db56&ts=true"
import script from "./MasterProductList.vue?vue&type=script&lang=ts"
export * from "./MasterProductList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__